import { fmt } from "../constants";

export default function CardsResumo({ contasPagar, contasReceber, fluxo }) {
  const cards = [
    {l:"A Pagar", v:contasPagar.filter(c=>["PENDENTE","VENCIDO"].includes(c.status)).reduce((s,c)=>s+parseFloat(c.valor),0), cor:"var(--z-danger-text)"},
    {l:"A Receber", v:contasReceber.filter(c=>["PENDENTE","VENCIDO"].includes(c.status)).reduce((s,c)=>s+parseFloat(c.valor),0), cor:"var(--z-blue)"},
    {l:"Entradas no Mes", v:fluxo?.entradas||0, cor:"var(--z-success-text)"},
    {l:"Saidas no Mes", v:fluxo?.saidas||0, cor:"var(--z-danger-text)"},
  ];
  return (
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
      {cards.map((card,i)=>(
        <div key={i} style={{background:"#fff",borderRadius:8,padding:"16px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:11,color:"var(--z-text-muted)",fontWeight:600,textTransform:"uppercase",marginBottom:4}}>{card.l}</div>
          <div style={{fontSize:20,fontWeight:700,color:card.cor}}>R$ {fmt(card.v)}</div>
        </div>
      ))}
    </div>
  );
}
